/** Merge extracted file text into the import textarea without slicing past the cap. */
export function mergeImportText(
  existing: string,
  extracted: string,
  maxChars: number,
): { ok: true; text: string } | { ok: false } {
  const trimmedExtracted = extracted.trim();
  const next = existing.trim()
    ? `${existing.trim()}\n\n${trimmedExtracted}`
    : trimmedExtracted;
  if (next.length > maxChars) return { ok: false };
  return { ok: true, text: next };
}
